import styles from './skeleton.module.css';

import type { JSX } from 'react';

export interface SkeletonProps {
  readonly width?: string;
  readonly height?: string;
  readonly label?: string;
}

export function Skeleton({ width, height, label = 'Loading' }: SkeletonProps): JSX.Element {
  return (
    <div
      className={[styles['block'], styles['pulse']].join(' ')}
      style={{ width, height }}
      role="status"
      aria-label={label}
    />
  );
}
